import React from 'react';
import { useSelector } from 'react-redux';
import { selectUser, getSubscription } from '../../../reducers/user.selectors';
import PricingPage from './PricingPage';
import NewPricingPage from './NewPricingPage';
import { newPricingPackageLicenceIds } from '../../../constants';

const PricingPageWrapper: React.FC = () => {
  const user = useSelector(selectUser);
  const subscription = useSelector(getSubscription);

  const currentPlanUsesNewPricing = subscription?.licence?.licenceModelId &&
      Object.values(newPricingPackageLicenceIds).includes(Number(subscription?.licence?.licenceModelId));

  // Special case: basis user without any subscription -> check feature flag
  if (user?.type === 1 && !subscription?.licence?.licenceModelId) {
    return <NewPricingPage />;
  }

  // If user has new pricing plan -> always show new pricing page
  if (currentPlanUsesNewPricing) {
    return <NewPricingPage />;
  }

  // If user has old pricing plan -> show old pricing page (regardless of feature flag)
  return <PricingPage />;
};

export default PricingPageWrapper;
